import { z } from 'zod';
export const updatePartnerFeaturesSchema = z
    .object({
    features: z
        .object({
        skuCreate: z.boolean().nullable(),
        skuEdit: z.boolean().nullable(),
        skuPhotoUpload: z.boolean().nullable(),
    })
        .strict(),
})
    .strict();
export const updateStaffAccessSchema = z
    .object({
    role: z.enum(['ADMIN', 'OPERATOR']),
    ownerAdmin: z.boolean(),
    restricted: z.boolean(),
    features: z
        .object({
        skuCreate: z.boolean().nullable(),
        skuEdit: z.boolean().nullable(),
        skuPhotoUpload: z.boolean().nullable(),
    })
        .strict()
        .optional(),
    scopes: z
        .array(z.object({
        scopeType: z.enum(['PARTNER', 'STORAGE_CUSTOMER']),
        scopeId: z.string().uuid(),
        canWrite: z.boolean(),
    }))
        .max(1000),
})
    .superRefine((value, ctx) => {
    if (value.ownerAdmin && (value.role !== 'ADMIN' || value.restricted)) {
        ctx.addIssue({ code: 'custom', message: 'Owner administrators must be unrestricted Admins' });
    }
    if (value.role === 'ADMIN' && !value.ownerAdmin && !value.restricted) {
        ctx.addIssue({ code: 'custom', message: 'Non-owner Admins must be restricted' });
    }
    const keys = value.scopes.map((s) => `${s.scopeType}:${s.scopeId}`);
    if (new Set(keys).size !== keys.length) {
        ctx.addIssue({ code: 'custom', message: 'Duplicate scopes' });
    }
});
//# sourceMappingURL=staff-access.js.map